import React, { useState } from "react";
import { DatePicker, Button, Table, message } from "antd";
import { retrieveHareKrishnaInvoiceDataForGst } from "../../api/PupilApi";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";

const GstDashboard = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [invoiceSummary, setInvoiceSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const safeToFixed = (val) => (typeof val === "number" ? val.toFixed(2) : "0.00");

  const fetchGstReport = async () => {
    if (!fromDate || !toDate) {
      message.error("Please select both From Date and To Date.");
      return;
    }
    setLoading(true);
    try {
      const response = await retrieveHareKrishnaInvoiceDataForGst(fromDate, toDate);
      console.log("responce" + response);
      const invoicesList = response.data?.data?.map(item => item.taxInvoiceDataInfo) || [];
      const filteredInvoices = invoicesList.filter(invoice => invoice.status !== "Cancelled");

      const summary = {};
      filteredInvoices.forEach(invoice => {
        const { shopEmail, shopName, billingAddress, invoiceNo, totalAmount, balance, paymentDetailsList, items, received, date } = invoice;
        console.log("invoice Date correction" + date);
        if (!items) {
          console.warn("Invoice has no items:", invoice);

        }

        let dateStr = date; // input date in yyyy-mm-dd format
        const [year, month, day] = dateStr.split("-"); // split by '-'

        const invoiceDate = `${day}-${month}-${year}`; // format to dd-mm-yyyy
        console.log("formation Date" + invoiceDate); // Output: 03-05-2025

        if (!summary[shopEmail]) {
          summary[shopEmail] = {
            shopEmail,
            shopName,
            invoiceDate,
            billingAddress,
            invoices: [],
            totalGst: 0,
            totalAmount: 0,
            totalBalance: 0,
            totalReceived: 0,
          };
        }

        let totalGst = (items || []).reduce((sum, item) => sum + parseFloat(item.gst || 0), 0);
        //const totalReceived = paymentDetails?.reduce((sum, p) => sum + (p?.paymentAmount || 0), 0) || 0;
        const totalReceived = received;
        const total = parseFloat(totalAmount || 0);
        const bal = parseFloat(balance || 0);

        summary[shopEmail].totalGst += totalGst;
        summary[shopEmail].totalAmount += total;
        summary[shopEmail].totalBalance += bal;
        summary[shopEmail].totalReceived += totalReceived;

        summary[shopEmail].invoices.push({ invoiceNo, total, totalGstPayable: totalGst, totalReceived, balance: bal, invoiceDate });
      });

      setInvoiceSummary(Object.values(summary));
      console.log("Invoice summary" + JSON.stringify(invoiceSummary));
    } catch (error) {
      console.error("Error fetching invoices:", error);
      message.error("Failed to fetch invoices");
    }
    setLoading(false);
  };

  const generatePdf = (shopData, isPreview = false) => {
    const doc = new jsPDF();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(96, 96, 96);
    const headerText1 = "GST Summary";
    const headerText2 = `From ${fromDate} to ${toDate}`;

    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth1 = doc.getTextWidth(headerText1);
    const textWidth2 = doc.getTextWidth(headerText2);


    doc.text(headerText1, (pageWidth - textWidth1) / 2, 10);
    doc.setFontSize(12);
    doc.text(headerText2, (pageWidth - textWidth2) / 2, 18);
    doc.text(`Shop: ${shopData.shopName}`, 18, 10);

    const tableData = shopData.invoices.map(inv => [
      inv.invoiceDate,
      inv.invoiceNo,
      safeToFixed(inv.total),
      safeToFixed(inv.totalGstPayable),
      safeToFixed(inv.totalReceived),
      safeToFixed(inv.balance)
    ]);

    doc.autoTable({
      startY: 20,
      head: [["InvoiceDate", "Invoice", "Total", "GST", "Received", "Balance"]],
      body: tableData,
      theme: 'grid',
      headStyles: { fillColor: [33, 76, 135] },
      styles: { fontSize: 10 },
    });

    doc.setTextColor(0, 0, 0);
    const y = doc.lastAutoTable.finalY;
    doc.text(`Total GST: Rs. ${safeToFixed(shopData.totalGst)}`, 15, y + 10);
    doc.text(`Total Amount: Rs. ${safeToFixed(shopData.totalAmount)}`, 15, y + 30);
    doc.text(`Ammount Received: Rs. ${safeToFixed(shopData.totalReceived)}`, 15, y + 20);
    doc.text(`Remaining Balance: Rs. ${safeToFixed(shopData.totalBalance)}`, 15, y + 40);

    if (isPreview) {
      window.open(doc.output("bloburl"), '_blank');
    } else {
      doc.save(`${shopData.shopName}_GST_Report.pdf`);
    }
  };

  const generateOverallPdf = (isPreview = false) => {
    const doc = new jsPDF();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(96, 96, 96);
    const headerText1 = "GST Summary";
    const headerText2 = `From ${fromDate} to ${toDate}`;

    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth1 = doc.getTextWidth(headerText1);
    const textWidth2 = doc.getTextWidth(headerText2);


    doc.text(headerText1, (pageWidth - textWidth1) / 2, 10);
    doc.setFontSize(12);
    doc.text(headerText2, (pageWidth - textWidth2) / 2, 18);

    const tableData = invoiceSummary.flatMap(shop =>
      shop.invoices.map(inv => [
        shop.invoiceDate,
        shop.shopName,
        inv.invoiceNo,
        safeToFixed(inv.total),
        safeToFixed(inv.totalGstPayable),
        safeToFixed(inv.totalReceived),
        safeToFixed(inv.balance)
      ])
    );

    doc.autoTable({
      startY: 20,
      head: [["Invoice Date", "Shop", "Invoice", "Total", "GST", "Received", "Balance"]],
      body: tableData,
      theme: 'grid',
      headStyles: { fillColor: [33, 76, 135] },
      styles: { fontSize: 10 },
    });

    const y = doc.lastAutoTable.finalY;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16)
    doc.setFont("helvetica", "bold");
    doc.text(`Overall GST: Rs. ${safeToFixed(overallGst)}`, 15, y + 10);
    doc.text(`Overall Amount: Rs. ${safeToFixed(overallTotal)}`, 15, y + 30);
    doc.text(`Received: Rs. ${safeToFixed(overallReceived)}`, 15, y + 20);
    doc.text(`Balance: Rs. ${safeToFixed(overallBalance)}`, 15, y + 40);

    if (isPreview) {
      window.open(doc.output("bloburl"), '_blank');
    } else {
      doc.save(`Overall_GST_Report.pdf`);
    }
  };

  const columns = [
    { title: "Shop Email", dataIndex: "shopEmail", key: "shopEmail" },
    { title: "Shop Name", dataIndex: "shopName", key: "shopName" },
    { title: "Billing Address", dataIndex: "billingAddress", key: "billingAddress" },
    {
      title: "Invoices",
      key: "invoices",
      render: (_, record) => (
        <Table
          columns={[
            { title: "InvoiceDate", dataIndex: "invoiceDate", key: "invoiceDate" },
            { title: "Invoice No", dataIndex: "invoiceNo", key: "invoiceNo" },
            { title: "Total", dataIndex: "total", key: "total", render: val => safeToFixed(val) },
            { title: "GST", dataIndex: "totalGstPayable", key: "gst", render: val => safeToFixed(val) },
            { title: "Received", dataIndex: "totalReceived", key: "received", render: val => safeToFixed(val) },
            { title: "Balance", dataIndex: "balance", key: "balance", render: val => safeToFixed(val) },
          ]}
          dataSource={record.invoices}
          pagination={false}
          rowKey="invoiceNo"
          size="small"
        />
      ),
    },
    {
      title: "PDF Actions",
      key: "pdf",
      render: (_, record) => (
        <div className="flex gap-2">
          <Button onClick={() => generatePdf(record)} type="link">Download</Button>
          <Button onClick={() => generatePdf(record, true)} type="link">Preview</Button>
        </div>
      ),
    },
  ];

  const overallGst = invoiceSummary.reduce((sum, shop) => sum + shop.totalGst, 0);
  const overallTotal = invoiceSummary.reduce((sum, shop) => sum + shop.totalAmount, 0);
  const overallBalance = invoiceSummary.reduce((sum, shop) => sum + shop.totalBalance, 0);
  const overallReceived = invoiceSummary.reduce((sum, shop) => sum + shop.totalReceived, 0);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <Button type="default" onClick={() => navigate(-1)}>Back</Button>
      </div>

      <div className="flex flex-wrap sm:flex-row items-center gap-4 mb-4">
        <DatePicker placeholder="Select From Date" onChange={(date, dateString) => setFromDate(dateString)} className="w-full sm:w-auto" />
        <DatePicker placeholder="Select To Date" onChange={(date, dateString) => setToDate(dateString)} className="w-full sm:w-auto" />
        <button type="submit" onClick={fetchGstReport} loading={loading} className="w-full sm:w-auto bg-[#3333FF] text-white">Submit</button>
      </div>

      <div className="overflow-x-auto bg-white rounded shadow p-2 sm:p-4">
        <Table
          columns={columns}
          dataSource={invoiceSummary}
          rowKey="shopEmail"
          pagination={{ pageSize: 2 }}
          expandable={{
            expandedRowRender: record => (
              <div className="text-right mt-2">
                <strong>Total Amount: </strong>{safeToFixed(record.totalAmount)} |
                <strong> Amount Received: </strong>{safeToFixed(record.totalReceived)} |
                <strong> Remaining Balance: </strong>{safeToFixed(record.totalBalance)} <br />
                <strong>Total GST: </strong>{safeToFixed(record.totalGst)}
              </div>
            ),
          }}
        />
        {invoiceSummary.length > 0 && (
          <>
            <div className="flex justify-between items-center mb-2">
              <div className="text-sm font-semibold">
                Overall Amount: {safeToFixed(overallTotal)} |
                Amount Received: {safeToFixed(overallReceived)} |
                Remaining Balance: {safeToFixed(overallBalance)} |
                <b> Overall GST:</b> {safeToFixed(overallGst)}
              </div>
              <div className="flex gap-2">
                <Button onClick={() => generateOverallPdf(true)} type="default">Preview Overall Report</Button>
                <Button onClick={() => generateOverallPdf(false)} type="default">Download Overall Report</Button>
              </div>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default GstDashboard;
